import requestAPI from './requestBeApi';

const getProfilePic = async (userType: string): Promise<void | string> => {
  if (!userType) return;

  const resp = await requestAPI({ method: 'GET', url: `/api/v1/${userType}s/me/profile-picture` });

  if (resp.ok) {
    const data = await resp.json();
    return data.url;
  } else if (resp.status !== 401) throw Error('User does not have a profile picture');
};

export default getProfilePic;
